<!--
 * @Descripttion:
 * @version:
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-04-11 13:43:43
 * @LastEditors: cwl
 * @LastEditTime: 2022-04-11 14:00:29
-->
<template>
	<div class="fen-ye">
		<div class="el_pagination" :class="{ishide:(totalPages==1)||(totalPages==0)||(totalPages=='')}">
			<el-pagination
				:page-size="1"
		        layout="prev, pager, next"
		        :total="totalPages"
			    background
			    @current-change='page'
			    >
			</el-pagination>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
export default{
    props: [
        'totalPages' // 总页数
    ],
    methods: {
        page (presentPageVal) { // 获取当前页码
            this.$emit('presentPage', presentPageVal)
        }
    }
}
</script>

<style lang="scss">
	.fen-ye {
		.el_pagination_box {
			overflow: hidden;
		}
		.el_pagination {
			height: 50px;
			position: relative;
		}
		.ishide {
			display: none;
		}
		.el-pagination {
			width: auto;
			overflow: hidden;
			float: left;
			position: absolute;
			top: 0;
			left: 50%;
			transform: translate(-50%, 0);
			-ms-transform: translate(-50%, 0);
			/* IE 9 */
			-webkit-transform: translate(-50%, 0);
			/* Safari and Chrome */
			-o-transform: translate(-50%, 0);
			/* Opera */
			-moz-transform: translate(-50%, 0);
		}

		.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
			width: 40px;
			height: 40px;
			border: 2px solid #D4D4D4;
			font-size: 18px;
			padding: 0;
			line-height: 36px;
			background-color: #fff;
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #AD011B;
			color: #fff;
			border: 0;
			line-height: 40px;
		}
		.el-pagination.is-background .el-pager li:not(.disabled):hover{
			color: #AD011B;
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active:hover{
			color: #fff;
		}
		.el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon{
			font-size: 18px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/fenye.vue